import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Hello! This application isnt ready yet.
          <br/>If you interested, let us know.
        </p>
      </header>
    </div>
  );
}

export default App;
